export default {"src":"/_next/static/media/urgent-en-leave-icon.23d0fc65.svg","height":48,"width":48};